import { FeatureEnabledState, getFeatureEnabled } from '../contexts/FeatureContext'

export const isEffectiveAllowMultipleRegistrations = (
  featureEnabledState: FeatureEnabledState | undefined,
  allowMultipleRegistrations?: boolean,
): boolean => {
  if (!allowMultipleRegistrations || !featureEnabledState?.isInitialized) {
    return false
  }

  return !!getFeatureEnabled(featureEnabledState, 'AllowMultipleRegistrationsPerVolunteer')
}
